<template>
    <el-dialog title="选择广告解锁方案" :visible.sync="innerVisible" class="dialog-table dialog-table10" width="800px" :before-close="closeDialogTable">
        <el-form :inline="true" ref="formInline" :model="formInline" size="small" class="demo-form-inline" @submit.native.prevent>
            <el-form-item label="方案名称：" prop="planName">
                <el-input type="text" v-model="formInline.planName" placeholder="请输入方案名称" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tableData" ref="singleTable" border  highlight-current-row
                @current-change="handleCurrentChangeTable" style="width: 100%" class="tableStyle table-radio">
            <el-table-column align="center" width="55" label>
                <template slot-scope="scope">
                    <!--<el-radio @change.native="handleCurrentChangeTable(scope.row)" v-model="selected" :label="scope.row.id">&nbsp;</el-radio>-->
                    <el-checkbox @change.native="handleCurrentChangeTable(scope.row)" v-model="selected" :label="scope.row.id"></el-checkbox>
                </template>
            </el-table-column>
            <el-table-column prop="programme" label="方案名称" width="150">
            </el-table-column>
            <el-table-column prop="svName" label="指定短剧" width="200">
                <template slot-scope="scope">
                    <span v-if="scope.row.type == 0">通用</span>
                    <span v-else>{{scope.row.svName}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="unlockInfo" label="广告解锁方案">
                <template slot-scope="scope">
                    <span v-if="scope.row.type == 0">看广告解锁{{scope.row.unlockEps}}集</span>
                    <ul>
                        <li v-for="(item, index) in scope.row.unlockInfoVo" :key="index">
                            第{{item.startEpNumber}}集开始，看广告解锁{{item.unlockEps}}集
                        </li>
                    </ul>
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogTable">取 消</el-button>
            <el-button type="primary" @click="tableSureBtn">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import { videoUnlockList } from "@/api/dysvzk/app/ad";
    export default {
        name: 'AdUnlockTable',
        // props: {
        //     visible: {
        //         type: Boolean,
        //         required: true
        //     },
        //     selectAdUnlock: {
        //         type: Object,
        //         required: true
        //     },
        //     svId: Number,
        //     posterId: Number
        // },
        props:['visible', 'selectAdUnlock', 'svId', 'posterId'],
        data() {
            return {
                innerVisible: this.visible,
                selected: [],
                tableData: [],
                currentPage: 1,
                pageSize: 100,
                currentRow: '',
                formInline:{
                    planName:''
                }
            }
        },
        watch: {
            visible(newValue) {
                this.innerVisible = newValue;
                console.log('posterId' , this.posterId)
                this.$nextTick(()=>{
                    this.formInline.planName = ''
                    this.$refs.singleTable.setCurrentRow(this.selectAdUnlock)
                    // if (this.posterId) {
                    //     console.log(111)
                    //     const row = this.tableData.find(row => row.id === this.posterId);
                    //     console.log(row)
                    //     this.$refs.singleTable.setCurrentRow(row);
                    // } else {
                    //     this.$refs.singleTable.setCurrentRow(this.selectAdUnlock)   
                    // }
                })
            },
            svId(newValue) {
                this.svId = newValue
                this.getTableAdUnlock()
            },
            // posterId(newValue) {
            //     this.posterId = newValue
            //     console.log('posterId' , this.posterId)
            //     console.log('tableData' ,this.tableData)
            //     this.$nextTick(() => {
            //         const row = this.tableData.find(row => row.id === newValue);
            //         console.log('row' ,row)
            //         if (row) {
            //             this.$refs.singleTable.setCurrentRow(row);
            //             this.currentRow = row
            //             this.selected = [row.id]
            //         }
            //     });
            // },
            innerVisible(newValue) {
                this.$emit('update:visible', newValue);
            }
        },
        mounted() {
            this.getTableAdUnlock()
        },
        methods: {
            search () {
                this.currentPage = 1
                this.getTableAdUnlock()
            },
            // 单选
            handleCurrentChangeTable(val) {
                console.log(val)
                this.$refs.singleTable.setCurrentRow(val);
                this.currentRow = val
                this.selected = [val.id]
                console.log(this.selected)
            },
            // 确定按钮
            tableSureBtn() {
                this.$emit('adUnlockSure', this.currentRow);
                this.$emit('cancelDialogAdUnlock', false);
                // this.closeDialogTable()
                // this.$refs.singleTable.setCurrentRow();
            },
            // 关闭弹框
            closeDialogTable () {
                console.log('关闭弹框')
                this.$emit('cancelDialogAdUnlock', false);
                // this.$refs.singleTable.setCurrentRow();
                // this.selected = []
            },
            getTableAdUnlock() {
                videoUnlockList({
                    svId: this.svId,
                    appId: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId,
                    planName:this.formInline.planName
                }).then(response => {
                    if (response.data.head.flag === 0) {
                        this.tableData = response.data.content
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });
            },
        }
    }
</script>
